/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Indicateinterest_Successdetails3Inputs */

const en_coinvestments_indicateinterest_successdetails3 = /** @type {(inputs: Coinvestments_Indicateinterest_Successdetails3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A member of the co-invest team will contact you as a next step`)
};

/**
* | output |
* | --- |
* | "A member of the co-invest team will contact you as a next step" |
*
* @param {Coinvestments_Indicateinterest_Successdetails3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_indicateinterest_successdetails3 = /** @type {((inputs?: Coinvestments_Indicateinterest_Successdetails3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Indicateinterest_Successdetails3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_indicateinterest_successdetails3(inputs)
});
export { coinvestments_indicateinterest_successdetails3 as "coInvestments_indicateInterest_successDetails" }